export default "__VITE_ASSET__DlgJ88ci__"